import { lazy } from "react"
import { GlobeAltIcon } from "@heroicons/react/24/outline"
import { Route, Routes } from "react-router-dom"
import { RouteElement } from "../../../interfaces/_common"
import { SubMenuTabs } from "../common"
import RouteKeys from "constants/route-keys"
const ShowMaster =  lazy(() => import("./ShowMaster"))
const UpdateShow = lazy(() => import("./ShowMaster/add-update"))


const _routes: RouteElement[] = [

    {
        route: '',
        title: 'Show',
        component: ShowMaster,
        icon: GlobeAltIcon,
        key: RouteKeys.SHOW,
        display: true
    },
    {
        route: '/update/:id',
        component: UpdateShow,
        title: 'Update Show',
        key: RouteKeys.SHOW,
        icon: GlobeAltIcon
    },
    {
        route: '/add',
        component: UpdateShow,
        title: 'Add Show',
        key: RouteKeys.SHOW,
        icon: GlobeAltIcon
    },
]

const ShowManagment = () => {
    return (
        <div>
            <SubMenuTabs _routes={_routes} />
            <div className="p-3">
                <Routes>
                    {
                        _routes.map((route, index) => (
                            <Route key={index} path={`${route.route}${route.hasChild ? '/*' : ''}`} element={<route.component />} />
                        ))
                    }
                </Routes>
            </div>
        </div>
    )
}

export default ShowManagment

